const Breadcrumbs = (props) => {
  const { loc, nameLink } = props;

  return (
    <div className="breadcrumb-containter">
      {((loc.pathname.split("/")[1] !== "auditForms" ||
        loc.pathname.split("/")[1] !== "audits" ||
        loc.pathname.split("/")[1] !== "escalations") &&
        !loc.pathname.split("/")[2] &&
        loc.pathname.split("/")[1] !== "forms" &&
        loc.pathname.split("/")[1] !== "feedback-requests") ||
      ((loc.pathname.split("/")[1] === "users" ||
        loc.pathname.split("/")[1] === "roles") &&
        loc.pathname.split("/")[2] &&
        loc.pathname.split("/")[1] !== "forms" &&
        loc.pathname.split("/")[1] !== "feedback-requests") ? (
        <div className="align-items-center d-flex name_search">
          <div className="namelinkclass">
            <a className="breadCrumb-parent">QMS</a>
            {nameLink}
          </div>
        </div>
      ) : (
        <>
          {loc.pathname.split("/")[1] === "forms" ||
          (loc.pathname.split("/")[1] === "feedback-requests" &&
            loc.pathname.split("/")[2] !== "preview") ? (
            <span className="namelinkclass name_search">
              {loc?.pathname.split("/")?.[1] &&
                loc?.pathname.split("/")?.[1].charAt(0).toUpperCase() +
                  loc?.pathname.split("/")?.[1].slice(1)}
            </span>
          ) : (
            <span className="namelinkclass name_search">
              {loc?.pathname.split("/")?.[1] &&
                loc?.pathname.split("/")?.[1].charAt(0).toUpperCase() +
                  loc?.pathname.split("/")?.[1].slice(1)}
              /#{loc.pathname.split("/")[2]}
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default Breadcrumbs;
